import { pluralize } from "constants/pluralize.js";
import { Axios } from "services/axios";

export const testimonialApi = {
  saveTestimonial: async (testimonialData) => {
    try {
      const formData = new FormData();

      // Append all basic fields
      formData.append('customerName', testimonialData.customerName || '');
      formData.append('customerDesignation', testimonialData.customerDesignation || '');
      formData.append('company', testimonialData.company || '');
      formData.append('testimonialText', testimonialData.testimonialText || '');
      formData.append('rating', testimonialData.rating?.toString() || '5');
      formData.append('featured', testimonialData.featured?.toString() || 'false');
      formData.append('active', testimonialData.active?.toString() || 'true');
      formData.append('order', testimonialData.order?.toString() || '0');

      // Append profile image file if available
      if (testimonialData.profileImageFile instanceof File) {
        formData.append('profileImage', testimonialData.profileImageFile);
      }

      // For editing, include the ID
      if (testimonialData.id) {
        formData.append('id', testimonialData.id);
      }

      // Debug: Check FormData contents
      // console.log("📦 API Layer - FormData Contents:");
      // for (let [key, value] of formData.entries()) {
      //   console.log(`  ${key}:`, value instanceof File ? `File: ${value.name}` : value);
      // }

      const response = await Axios.post('/testimonial/addTestimonial', formData, {
        'Content-Type': 'multipart/form-data',
      });
      return response.data?.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to save testimonial');
    }
  },

  assignTestimonialToPages: async (testimonialId, pageAssignments) => {
    try {
      const response = await Axios.post(`/testimonial/${testimonialId}/assign-pages`, {
        pageAssignments
      });
      return response.data?.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to assign testimonial to pages');
    }
  },

  getAllTestimonials: async (page = 1, limit = 10, search = '', pageId = null) => {
    try {
      let url = `/testimonial/all?page=${page}&limit=${limit}`;
      if (search) url += `&search=${search}`;
      if (pageId) url += `&pageId=${pageId}`;

      const response = await Axios.fetch(url);
      return response.data?.data || { testimonials: [], pagination: {} };
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch testimonials');
    }
  },

  getTestimonialAssignments: async (testimonialId) => {
    try {
      const response = await Axios.fetch(`/testimonial/${testimonialId}/assignments`);
      return response.data?.data || [];
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to fetch testimonial assignments');
    }
  },

  deleteTestimonial: async (testimonialId) => {
    try {
      await Axios.delete(`/testimonial/testimonialById/${testimonialId}`);
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to delete testimonial');
    }
  },

  updateTestimonialStatus: async (testimonialId, active) => {
    try {
      const response = await Axios.put(`/testimonial/${testimonialId}/status`, { active });
      return response.data?.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || 'Failed to update testimonial status');
    }
  },

  getEntities: async (entityType) => {
    try {
      const endpoint = pluralize(entityType);
      const response = await Axios.fetch(`/testimonial/entities/${endpoint}`);
      return response.data?.data || [];
    } catch (error) {
      throw new Error(error.response?.data?.message || `Failed to fetch ${entityType}s`);
    }
  }
};
